import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroPontoEmbarque from '../../actions/pontoEmbarque/adicionarFiltroPontoEmbarque'
import removerFiltroPontoEmbarque from '../../actions/pontoEmbarque/removerFiltroPontoEmbarque'
import FiltroBusca from '../comum/FiltroBusca'

export class FiltroBuscarPontoEmbarque extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isNome={this.props.isNome}
        adicionarFiltro={this.props.adicionarFiltroPontoEmbarque}
        removerFiltro={this.props.removerFiltroPontoEmbarque}
      />
    )
  }
}

const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosPontoEmbarque
})

const mapDispatchToProps = dispatch => bindActionCreators({
  adicionarFiltroPontoEmbarque,
  removerFiltroPontoEmbarque
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscarPontoEmbarque)
